"use client";

import { useEffect } from "react";
import { useAppStore } from "@/store/useAppStore";

export function TrackRecentDog({ id }: { id: number }) {
  const addRecentDog = useAppStore((state) => state.addRecentDog);
  useEffect(() => { addRecentDog(id); }, [addRecentDog, id]);
  return null;
}
